import React, { Component } from 'react';
import 'styled-components/macro';
import * as types from 'styled-components/cssprop'; /* eslint-disable-line */
import { RootDispatch, RootState } from '../../models/configure_store';
import { css, withTheme } from 'styled-components';
import { connect } from 'react-redux';
import VerifyMessage from '../verify-message';
import { getCaptchaDomains } from '../../service/captcha';
import { scale, isMobile } from '@/utils/constants';
import { baseRem } from '@/utils/rem';
import * as logger from '../../utils/logger';

const mapState = ({ captcha }: RootState) => {
  const {
    selected_pos,
    outer_url,
    inner_url,
    verify_status,
    loading,
    drag_pos,
    mode,
    verify_result_msg,
    show_verify_msg,
    point_add_able,
    challenge_code,
    challenge_id,
    challenge_mode,
    uuid,
    isFetch,
    isTooFrequently,
    refresh_btn_able,
    backup_url1,
    backup_url2,
    backup_url1Index,
    backup_url2Index,
  } = captcha;
  return {
    drag_pos,
    outer_url,
    inner_url,
    selected_pos,
    verify_status,
    loading,
    mode,
    verify_result_msg,
    show_verify_msg,
    point_add_able,
    challenge_code,
    challenge_id,
    challenge_mode,
    uuid,
    isFetch,
    isTooFrequently,
    refresh_btn_able,
    backup_url1,
    backup_url2,
    backup_url1Index,
    backup_url2Index,
  };
};
const mapDispatch = ({ captcha }: RootDispatch) => {
  return {
    addPos: captcha.addPos,
    removePos: captcha.removePos,
    update: captcha.update,
  };
};
type VerifyImageCircleProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch> & {
    sliding: boolean;
    onMouseMove: () => void;
    img_error_text: string;
    lang: string;
    show: boolean;
    theme: any;
  };
class VerifyImageCircle extends Component<VerifyImageCircleProps> {
  $canvas!: HTMLDivElement;
  domains?: string[]; // 保存图片备用域名
  domainQuestionIndex: number = 0; // 验证码大图循环调度第几个domains域名
  domainAnswerIndex: number = 0; // 验证码拼图第几个domains域名
  loadOuterImgSuccess: boolean = false; // 是否加载地图成功
  loadInnerImgSuccess: boolean = false; // 是否加载拼图成功
  scheduleStatus: 'none' | 'pending' | 'end' = 'none'; // 大图的调度状态，用于埋点上报标识调度状态
  start_time: number = Date.now();
  timeout: number = -1;

  state = {
    imgUrlError: false,
  };

  componentWillReceiveProps = (nextProps: any) => {
    // uuid变化说明重新了验证码，需要对数据初始化状态
    if (nextProps.uuid !== this.props.uuid) {
      this.loadOuterImgSuccess = false;
      this.loadInnerImgSuccess = false;
      this.scheduleStatus = 'none';
      if (this.domains) {
        this.domainQuestionIndex = this.domainAnswerIndex =
          this.domains.length - 1;
      }
      // 图片发生变化，重置初始时间
      this.start_time = Date.now();
    }
  };

  // 获取备选调度域名组
  getCaptchaDomains = async () => {
    let data = [];
    try {
      const res = await getCaptchaDomains();
      data = res.data || [];
    } catch {}
    this.domains = data;
    this.domainQuestionIndex = this.domainAnswerIndex = data.length - 1;
  };
  // 域名调度，如果图片加载失败，在从备用域名中选取再次加载
  domainsSchedule(
    url: string,
    key: 'outer_url' | 'inner_url',
    index: 'domainQuestionIndex' | 'domainAnswerIndex'
  ): boolean {
    if (this.domains && this[index] >= 0) {
      // 正则替换调度新域名
      const new_url = url.replace(
        /^(https:)\/\/([\s\S]+?)\//,
        `$1//${this.domains[this[index]]}/`
      );
      if (new_url === url) {
        // 后端返回的domains可能会重复，比如[s1, s2, s2]，update会不起作用，需要规避掉
        this[index]--;
        return this.domainsSchedule(url, key, index);
      }
      this.props.update({
        [key]: new_url,
      });
      this[index]--;
      return true;
    }
    return false;
  }
  // 背景图片加载错误调度处理
  imgErrorHandler = async (key: 'outer_url' | 'inner_url') => {
    const {
      update,
      img_error_text,
      backup_url1,
      backup_url2,
      backup_url1Index,
      backup_url2Index,
    } = this.props;
    const url = this.props[key];
    if (key === 'outer_url' && backup_url1Index >= 0) {
      update({
        outer_url: backup_url1[backup_url1Index],
        backup_url1Index: backup_url1Index - 1,
      });
      this.scheduleStatus = backup_url1Index - 1 < 0 ? 'end' : 'pending';
      this.imgLoadLog('failed', key);
      return;
    } else if (key === 'inner_url' && backup_url2Index >= 0) {
      update({
        inner_url: backup_url2[backup_url2Index],
        backup_url2Index: backup_url2Index - 1,
      });
      this.imgLoadLog('failed', key);
      return;
    } else {
      this.imgLoadLog('failed', key);
      this.setState({
        imgUrlError: true,
      });
    }
    if (url.trim()) {
      // 提示刷新
      update({
        show_verify_msg: true,
        verify_result_msg: img_error_text,
        isFetch: false,
        refresh_btn_able: true,
        loading: false,
      });
    }
  };
  // 图片加载埋点
  imgLoadLog = (
    status: 'succeed' | 'failed',
    failed_url_type: 'inner_url' | 'outer_url' | 'null'
  ) => {
    const { challenge_mode, challenge_id, challenge_code } = this.props;
    const duration = Date.now() - this.start_time;
    const inner_img_domain_res =
      this.props.inner_url.match(/\/\/(.+?)\//)?.[1] || null;
    const outer_img_domain_res =
      this.props.outer_url.match(/\/\/(.+?)\//)?.[1] || null;
    const logData = {
      duration,
      mode: challenge_mode,
      is_success: 1,
      challenge_id,
      challenge_code,
      img1: this.props.outer_url,
      img2: this.props.inner_url,
      schedule_status: this.scheduleStatus,
      failed_url_type,
    };
    if (status === 'failed') {
      logData.is_success = 0;
    }
    logger.trackEvent('show_picture', logData);
  };
  // 图片加载成功处理
  onImgLoad = (type: 'loadOuterImgSuccess' | 'loadInnerImgSuccess') => {
    const { update, isTooFrequently } = this.props;
    this[type] = true;
    if (
      !isTooFrequently &&
      this.loadOuterImgSuccess &&
      this.loadInnerImgSuccess
    ) {
      this.imgLoadLog('succeed', 'null');
      update({
        isFetch: false,
        show_verify_msg: false,
        point_add_able: true,
        refresh_btn_able: true,
      });
      this.timeout = setTimeout(() => {
        update({
          slide_btn_able: true,
        });
      }, 400);
    }
  };
  componentDidUpdate = () => {
    // 在点击刷新后清除定时器
    if (this.props.refresh_btn_able === false) {
      clearTimeout(this.timeout);
    }
  };
  render() {
    const {
      outer_url,
      inner_url,
      verify_status,
      loading,
      drag_pos,
      onMouseMove,
      verify_result_msg,
      show_verify_msg,
      isFetch,
      lang,
      isTooFrequently,
      show,
      theme,
    } = this.props;
    const { imgUrlError } = this.state;
    const angle = (drag_pos.x / ((scale * 222 * baseRem) / 100)) * 180;
    const outBase = Math.round(scale * 171);
    const innerBase = Math.round(scale * 105);
    return (
      <div
        css={css`
          height: ${isMobile ? 1.72 : 2.12}em;
          width: ${isMobile ? 2.76 : 3.4}em;
          margin: ${scale * 0.195}em ${isMobile ? 0.12 : 0.2}em;
          box-sizing: border-box;
          position: relative;
          overflow: hidden;
        `}
        onMouseMove={onMouseMove} // 将图片的mousermove轨迹扩展到了整个验证码的轨迹
      >
        {outer_url && (
          <img
            draggable={false}
            css={`
              user-drag: none;
              -webkit-user-drag: none;
              height: ${(outBase + 1) / 100}em;
              width: ${(outBase + 1) / 100}em;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              border-radius: 50%;
            `}
            src={outer_url}
            style={{
              transformOrigin: 'center',
              WebkitTransformOrigin: 'center',
              msTransformOrigin: 'center',
              transform: `translate(-50%, -50%) rotateZ(-${angle}deg)`,
              WebkitTransform: `translate(-50%, -50%) rotateZ(-${angle}deg)`,
              msTransform: `translate(-50%, -50%) rotateZ(-${angle}deg)`,
              visibility: `${
                imgUrlError ||
                !outer_url ||
                (isFetch && !isTooFrequently) ||
                !show
                  ? 'hidden'
                  : 'visible'
              }` as any,
            }}
            onError={() => outer_url && this.imgErrorHandler('outer_url')}
            onLoad={() => this.onImgLoad('loadOuterImgSuccess')}
          />
        )}
        <div
          // 外圆的白色边框（用于遮挡锯齿）
          css={`
            user-drag: none;
            -webkit-user-drag: none;
            height: ${outBase / 100}em;
            width: ${outBase / 100}em;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            border: 2px solid ${theme.bgColor};
            border-radius: 50%;
            box-sizing: content-box;
          `}
          style={
            drag_pos.x === 0
              ? {
                  background: 'rgba(0,0,0,0.36)',
                }
              : {}
          }
        />
        {/* <div
          // 外圆的内边框
          css={`
            user-drag: none;
            -webkit-user-drag: none;
            height: ${((outBase - 1) * 2) / 100}em;
            width: ${((outBase - 1) * 2) / 100}em;
            position: absolute;
            left: 50%;
            top: 50%;
            border-radius: 50%;
            transform: translate(-50%, -50%) scale(0.5);
            border: 1px solid #e8e8e8;
            box-sizing: content-box;
          `}
        /> */}
        {inner_url && (
          <img
            draggable={false}
            css={`
              user-drag: none;
              -webkit-user-drag: none;
              height: ${(innerBase + 1) / 100}em;
              width: ${(innerBase + 1) / 100}em;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              border-radius: 50%;
            `}
            src={inner_url}
            style={{
              transformOrigin: 'center',
              WebkitTransformOrigin: 'center',
              msTransformOrigin: 'center',
              transform: `translate(-50%, -50%) rotateZ(${angle}deg)`,
              WebkitTransform: `translate(-50%, -50%) rotateZ(${angle}deg)`,
              msTransform: `translate(-50%, -50%) rotateZ(${angle}deg)`,
              visibility: `${
                imgUrlError ||
                !inner_url ||
                (isFetch && !isTooFrequently) ||
                !show
                  ? 'hidden'
                  : 'visible'
              }` as any,
            }}
            onError={() => inner_url && this.imgErrorHandler('inner_url')}
            onLoad={() => this.onImgLoad('loadInnerImgSuccess')}
          />
        )}
        {!show_verify_msg && (
          <div
            // 内圆的白色边框
            css={`
              user-drag: none;
              -webkit-user-drag: none;
              height: ${innerBase / 100}em;
              width: ${innerBase / 100}em;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              border: 2px solid #fff;
              border-radius: 50%;
              box-sizing: content-box;
            `}
          />
        )}
        {show_verify_msg && (
          <VerifyMessage
            isFetch={isFetch}
            loading={loading}
            status={verify_status}
            verify_result_msg={verify_result_msg}
            challenge_mode={'whirl'}
            lang={lang}
            isTooFrequently={isTooFrequently}
          />
        )}
      </div>
    );
  }
}
export default withTheme(
  connect(mapState, mapDispatch as any)(VerifyImageCircle) as any
);
